import { dateUtils } from '@festina-life/core'
import { RawDatePicker } from '@festina-life/ui/forms'
import debounce from 'lodash-es/debounce'
import { useEffect, useRef, useState } from 'react'

import { useConfigurationContext } from '../../context/configurationContext'

export const ViewAtDatePicker = () => {
  const { viewAt, onViewAtChanged } = useConfigurationContext()
  const value = dateUtils.dateAsServerStr(viewAt)
  const [inputValue, setInputValue] = useState(value ?? '')

  const handleViewAtChangedDebounced = useRef(
    debounce((nextDate: Date) => onViewAtChanged(nextDate), 1000),
  )

  useEffect(() => {
    if (value) {
      // Use the functional form so React can bail out when the value hasn't
      // changed: returning `prev` (===) prevents a re-render and stops
      // effect 2 from being scheduled again, which would cause an infinite loop.
      setInputValue((prev) => (prev === value ? prev : value))
    }
  }, [value])

  useEffect(() => {
    // dateUtcAsLocal parses date-only strings as local time, avoiding UTC drift.
    const nextDate = dateUtils.dateUtcAsLocal(inputValue).toDate()
    if (isNaN(nextDate.getTime())) {
      return
    }

    handleViewAtChangedDebounced.current(nextDate)
  }, [inputValue])

  return (
    <RawDatePicker
      name="viewAt"
      data-testid="view-at-date-picker"
      className="w-min"
      value={inputValue}
      onChange={setInputValue}
    />
  )
}
